module.exports = __webpack_public_path__ + "images/bi-logo-778b2fc7.png";